module.exports = __webpack_public_path__ + "static/media/HB_rainbowsalad_square_forweb.db4e4be7.jpg";